/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import {
  IGetStateProvinceSuccess,
  IGetStateProvinceFailure,
  IGetStateProvinceShippingSuccess,
  IGetStateProvinceShippingFailure,
  IGetStateProvinceSchoolSuccess,
  IGetStateProvinceSchoolFailure,
} from "./StateProvinceAction";
import {
  STATEPROVINCEDATA_LOAD_SUCCESS,
  STATEPROVINCEDATA_LOAD_FAILURE,
  STATEPROVINCESHIPPING_LOAD_SUCCESS,
  STATEPROVINCESHIPPING_LOAD_FAILURE,
  STATEPROVINCESCHOOL_LOAD_SUCCESS,
  STATEPROVINCESCHOOL_LOAD_FAILURE,
} from "../../Constants/ActionTypes";
import { IStateProvinceDataState } from "../../Interfaces/SiteContent";

const initialState: IStateProvinceDataState = {
  stateProvinces: [],
  stateProvincesShipping: [],
  stateProvincesSchool: [],
  stateProvincesOptionList: [],
  stateProvincesShippingOptionList: [],
  stateProvincesSchoolOptionList: [],
  stateProvincesLoadError: "",
  stateProvincesShippingLoadError: "",
  stateProvincesSchoolLoadError: "",
};

/**
 *
 * @param state
 * @param action
 */
const applyLoadStateProvince = (
  state: IStateProvinceDataState,
  action: IGetStateProvinceSuccess
): IStateProvinceDataState => ({
  ...state,
  stateProvinces: action.stateProvinces,
  stateProvincesOptionList: action.stateProvinces.map((x) => ({
    key: x.stateProvinceName,
    text: x.stateProvinceName,
    id: x.stateProvinceId,
    countryRegionId: x.countryRegionId,
  })),
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadFailStateProvinces = (
  state: IStateProvinceDataState,
  action: IGetStateProvinceFailure
): IStateProvinceDataState => ({
  ...state,
  stateProvincesLoadError: action.stateProvincesLoadError,
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadStateProvinceShipping = (
  state: IStateProvinceDataState,
  action: IGetStateProvinceShippingSuccess
): IStateProvinceDataState => ({
  ...state,
  stateProvincesShipping: action.stateProvincesShipping,
  stateProvincesShippingOptionList: action.stateProvincesShipping.map((x) => ({
    key: x.stateProvinceName,
    text: x.stateProvinceName,
    id: x.stateProvinceId,
    countryRegionId: x.countryRegionId,
  })),
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadFailStateProvinceShipping = (
  state: IStateProvinceDataState,
  action: IGetStateProvinceShippingFailure
): IStateProvinceDataState => ({
  ...state,
  stateProvincesShippingLoadError: action.stateProvincesShippingLoadError,
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadStateProvinceSchool = (
  state: IStateProvinceDataState,
  action: IGetStateProvinceSchoolSuccess
): IStateProvinceDataState => ({
  ...state,
  stateProvincesSchool: action.stateProvincesSchool,
  stateProvincesSchoolOptionList: action.stateProvincesSchool.map((x) => ({
    key: x.stateProvinceName,
    text: x.stateProvinceName,
    id: x.stateProvinceId,
    countryRegionId: x.countryRegionId,
  })),
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadFailStateProvinceSchool = (
  state: IStateProvinceDataState,
  action: IGetStateProvinceSchoolFailure
): IStateProvinceDataState => ({
  ...state,
  stateProvincesSchoolLoadError: action.stateProvincesSchoolLoadError,
});

/**
 *
 * @param state
 * @param action
 */
function stateProvinceReducer(state: IStateProvinceDataState = initialState, action) {
  switch (action.type) {
    case STATEPROVINCEDATA_LOAD_SUCCESS:
      return applyLoadStateProvince(state, action);
    case STATEPROVINCEDATA_LOAD_FAILURE:
      return applyLoadFailStateProvinces(state, action);
    case STATEPROVINCESHIPPING_LOAD_SUCCESS:
      return applyLoadStateProvinceShipping(state, action);
    case STATEPROVINCESHIPPING_LOAD_FAILURE:
      return applyLoadFailStateProvinceShipping(state, action);
    case STATEPROVINCESCHOOL_LOAD_SUCCESS:
      return applyLoadStateProvinceSchool(state, action);
    case STATEPROVINCESCHOOL_LOAD_FAILURE:
      return applyLoadFailStateProvinceSchool(state, action);
    default:
      return state;
  }
}

export default stateProvinceReducer;
